import { ServiceBay, ServiceBaySchedule } from "../../../../../../models/serviceBay";
import SchedulingCard from "./SchedulingCard";
import useMediaQuery from "@mui/material/useMediaQuery";

interface IDayProps {
  serviceBays: ServiceBay[];
  firstWeekDay: Date;
  currentDate: Date;
  consultantMonthSchedule: ServiceBaySchedule[];
  openScheduleModal: (schedule: ServiceBaySchedule) => void;
}

const Day = ({
  serviceBays,
  currentDate,
  consultantMonthSchedule,
  openScheduleModal,
}: IDayProps) => {
  const isResponsiveView = useMediaQuery("(max-width: 1024px)");

  const getCard = (date: Date, hour: number) => {
    if (getServiceBaySchedule(date, hour)) {
      return (
        <SchedulingCard
          serviceBaySchedule={getServiceBaySchedule(date, hour)!}
          openScheduleModal={() =>
            openScheduleModal(getServiceBaySchedule(date, hour)!)
          }
          atPoint="start"
          showScheduleDate={serviceBays.length === 1}
        />
      );
    } else if (getFullDayServiceBaySchedule(date, hour)) {
      return (
        <SchedulingCard
          serviceBaySchedule={getFullDayServiceBaySchedule(date, hour)!}
          openScheduleModal={() =>
            openScheduleModal(getFullDayServiceBaySchedule(date, hour)!)
          }
          atPoint="allDay"
          showScheduleDate={serviceBays.length === 1}
        />
      );
    } else if (getRemainingDayServiceBaySchedule(date, hour)) {
      return (
        <SchedulingCard
          serviceBaySchedule={getRemainingDayServiceBaySchedule(date, hour)!}
          openScheduleModal={() =>
            openScheduleModal(getRemainingDayServiceBaySchedule(date, hour)!)
          }
          atPoint="end"
          showScheduleDate={serviceBays.length === 1}
        />
      );
    }
    return null;
  };

  const getServiceBaySchedule = (
    date: Date,
    hour: number
  ): ServiceBaySchedule | undefined => {
    return consultantMonthSchedule.find(
      (schedule) =>
        schedule.startDate?.getDate() === date.getDate() &&
        schedule.startDate?.getMonth() === date.getMonth() &&
        schedule.startDate?.getFullYear() === date.getFullYear() &&
        schedule.startHour?.getHours() === hour
    );
  };

  const getFullDayServiceBaySchedule = (
    date: Date,
    hour: number
  ): ServiceBaySchedule | undefined => {
    if (hour !== 0) return undefined;
    return consultantMonthSchedule.find((schedule) => {
      if (
        !schedule.startDate ||
        !schedule.endDate ||
        schedule.startDate?.getMonth() !== date.getMonth() ||
        schedule.startDate?.getFullYear() !== date.getFullYear()
      )
        return false;
        
      // 00h00 do date
      const startOfDay = new Date(date);
      startOfDay.setHours(0, 0, 0, 0);
      
      // 23h59 do date
      const endOfDay = new Date(date);
      endOfDay.setHours(23, 59, 59, 999);
      
      // Verifica se o schedule começa antes das 00h do date e termina depois de 23h59 do date
      return schedule.startDate < startOfDay && schedule.endDate > endOfDay;
    });
  };

  const getRemainingDayServiceBaySchedule = (
    date: Date,
    hour: number
  ): ServiceBaySchedule | undefined => {
    if (hour !== 0) return undefined;
    return consultantMonthSchedule.find((schedule) => {
      if (
        !schedule.startDate ||
        !schedule.endDate ||
        schedule.startDate?.getMonth() !== date.getMonth() ||
        schedule.startDate?.getFullYear() !== date.getFullYear()
      )
        return false;

      // 00h00 do date
      const startOfDay = new Date(date);
      startOfDay.setHours(0, 0, 0, 0);
      
      // 23h59 do date
      const endOfDay = new Date(date);
      endOfDay.setHours(23, 59, 59, 999);
      
      // Desconsidera se o endDate for menor que o startOfDay ou se o startDate for maior que o endOfDay
      if (schedule.endDate < startOfDay || schedule.startDate > endOfDay) {
        return false;
      }
      
      // Verifica se o schedule começa antes das 00h do date e termina antes de 23h59 do date
      return schedule.startDate < startOfDay && schedule.endDate < endOfDay;
    });
  };

  return (
    <table className="width-100pct table-fixed">
      <thead>
        <tr>
          <th className={`height-20 ${isResponsiveView ? 'width-20' : 'width-10'}`}></th>
          <th style={{ width: isResponsiveView ? 'calc(100% / 80px)' : 100 }} />
        </tr>
      </thead>
      <tbody>
        {Array.from({ length: 24 }).map((_, hour) => {
          return (
            <tr key={hour}>
              <td className="display-flex justify-content-center align-items-center"
                style={{
                  width: isResponsiveView ? 80 : 'auto',
                  minWidth: isResponsiveView ? 80 : 'auto',
                  fontSize: isResponsiveView ? '12px' : '14px',
                  padding: isResponsiveView ? '5px' : '8px'
                }}>{`${hour < 10 ? `0${hour}` : hour}:00`}</td>
              <td style={{
                height: isResponsiveView ? 50 : 60,
                width: isResponsiveView ? 'calc(100% - 80px)' : 100
              }} className={`border`}>
                {getCard(currentDate, hour)}
              </td>
            </tr>
          );
        })}
      </tbody>
    </table>
  );
};

export default Day;
